<checkout-header [host]="host" [cart]="cart"
                 [step]="getNextStep()"
                 (back)="back()" (next)="next()" [canProceed]="canProceed()"></checkout-header>

<main class="container" *ngIf="cart && menu">
  <div *ngIf="host.has_delivery || host.has_takeout">
    <h5 class="mt-3"><i class="fa fa-clock"></i>&nbsp;
      <span *ngIf="cart.method == OrderMethod.delivery" i18n>Choose delivery time</span>
      <span *ngIf="cart.method == OrderMethod.takeout" i18n>Choose takeout time</span>
    </h5>

    <div class="alert alert-success" *ngFor="let entry of discounts">
      <discount-entry [entry]="entry">
        <discount-time-condition [condition]="condition" *ngFor="let condition of entry.discount.conditions"></discount-time-condition>
      </discount-entry>
    </div>

    <opening-hours-warning [host]="host" [table]="table"></opening-hours-warning>

    <time-zone-warning [host]="host"></time-zone-warning>

    <div class="list-group">
      <a href="#" class="list-group-item list-group-item-action is-clickable time-asap"
         [class.active]="mode=='asap'" (click)="setMode('asap')">
        <div class="row">
          <div class="col">
            <h6 class="mb-1">
              <check-circle [active]="mode=='asap'"></check-circle>
              &nbsp;<span i18n>As soon as possible</span></h6>
            <p class="mb-1">
              <span *ngIf="cart.method==OrderMethod.delivery" i18n>Estimated delivery time: about</span>
              <span *ngIf="cart.method==OrderMethod.takeout" i18n>Estimated pickup time: about</span>
              {{ cart.getEarliestDeliveryTime()|date:"HH:mm" }}</p>
          </div>
        </div>
      </a>
      <a href="#" class="list-group-item list-group-item-action is-clickable time-preorder"
         [class.active]="mode=='preorder'" (click)="setMode('preorder')">
        <div class="row">
          <div class="col">
            <h6 class="mb-1">
              <check-circle [active]="mode=='preorder'"></check-circle>
              &nbsp;<span i18n>Preorder</span>
            </h6>
            <p class="mb-1" *ngIf="cart.method==OrderMethod.delivery" i18n>Choose your preferred delivery time</p>
            <p class="mb-1" *ngIf="cart.method==OrderMethod.takeout" i18n>Choose your preferred pickup time</p>
          </div>
        </div>
      </a>
    </div>

    <form class="t4d-form mt-3" [formGroup]="form" (ngSubmit)="onFormSubmit()" *ngIf="mode=='preorder'">
      <div class="form-group mt-2">
        <label for="id_day">
          <span *ngIf="cart.method == OrderMethod.delivery" i18n>Delivery day*</span>
          <span *ngIf="cart.method == OrderMethod.takeout" i18n>Takeout day*</span>
        </label>
        <select id="id_day" class="form-control hide-validation-success" required formControlName="day">
          <option *ngFor="let d of preorder_times" [ngValue]="d.day">{{d.label}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="id_time">
          <span *ngIf="cart.method == OrderMethod.delivery" i18n>Delivery time*</span>
          <span *ngIf="cart.method == OrderMethod.takeout" i18n>Takeout time*</span>
        </label>
        <select id="id_time" class="form-control hide-validation-success" required formControlName="time">
          <option *ngFor="let t of slots" [ngValue]="t">{{t|ordertime}}</option>
        </select>
      </div>
    </form>

  </div>

  <div class="mt-3 mb-3 row">
    <div class="col-5 text-left">
      <button class="btn btn-secondary" (click)="back()"><i class="far fa-arrow-alt-circle-left"></i>&nbsp;<span i18n>Back</span></button>
    </div>
    <div class="col-7 text-right">
      <next-step-button [cart]="cart" [step]="getNextStep()" [enabled]="canProceed()" (next)="next()"></next-step-button>
    </div>
  </div>

</main>
